import { render, staticRenderFns } from "./GjwStatusCell.vue?vue&type=template&id=5128392b&scoped=true"
import script from "./GjwStatusCell.vue?vue&type=script&lang=js"
export * from "./GjwStatusCell.vue?vue&type=script&lang=js"
import style0 from "./GjwStatusCell.vue?vue&type=style&index=0&id=5128392b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128392b",
  null
  
)

export default component.exports